import {
  RECEIVE_ASSETS,
  RECEIVING_ASSET,
  RECEIVE_ASSET_METADATA,
  RECEIVE_ASSET_FAILURE,
  SAVING_ASSET,
  SAVING_ASSET_FAILURE,
  UPDATING_ASSET,
  UPDATING_ASSET_FAILURE,
  DELETE_ASSET,
  DELETING_ASSET,
  DELETING_ASSET_FAILURE,
  CLEAR_ASSET_STATE,
  RESET_ASSET_META,
  CLEAR_STATE,
  INCREMENT_ASSET_COUNT
} from '../mutationTypes'
import {
  receiveData,
  deleteData,
  increment,
  receiveMetadata,
  resetMetadata,
  clearLocalState,
  clearState
} from '@/store/modules/helpers/mutationHelpers'

const state = {
  data: {},
  cache: {},
  count: null,
  shown: null,
  next: null,
  previous: null,
  currentPage: 1,
  saving: false,
  saveFailure: null,
  receivingData: false,
  receiveDataFailure: false,
  updating: null,
  updateFailure: null,
  deleting: false
}

const getters = {
  getAssets: (state) => {
    return state.data ? Object.values(state.data).map(v => Object.assign({}, v)) : []
  },
  getAssetMetadata: (state) => {
    const { shown, count, previous, next } = state
    if (!shown) return { count: 0, shown: 0 }
    return { count, shown, previous, next }
  },
  getAssetById: (state) => (id) => {
    if (state.data && state.data[id]) {
      return state.data[id]
    } else if (state.cache && state.cache[id]) {
      return state.cache[id]
    } else {
      return {}
    }
  },
  getAssetFetchStatus: (state) => {
    return state.receivingData
  },
  getAssetSaveStatus: (state) => {
    return state.saving
  },
  getAssetSaveFailure: (state) => {
    return state.saveFailure
  },
  getAssetUpdateStatus: (state) => {
    return state.updating
  },
  getAssetUpdateFailure: (state) => {
    return state.updateFailure
  },
  getAssetDeleteStatus: (state) => {
    return state.deleting
  },
  getCurrentAssetPage: (state) => {
    if (state.currentPage) return state.currentPage
  }
}

const mutations = {
  [RECEIVE_ASSETS] (state, results) {
    receiveData(state, results)
  },
  [RECEIVING_ASSET] (state, payload) {
    state.receivingData = payload
  },
  [RECEIVE_ASSET_FAILURE] (state, error) {
    state.receiveDataFailure = error
  },
  [SAVING_ASSET] (state, payload) {
    state.saving = payload
  },
  [SAVING_ASSET_FAILURE] (state, payload) {
    state.saveFailure = payload
  },
  [UPDATING_ASSET] (state, payload) {
    state.updating = payload
  },
  [UPDATING_ASSET_FAILURE] (state, payload) {
    const { id, err } = payload
    state.updateFailure = { id, err }
  },
  [DELETE_ASSET] (state, payload) {
    deleteData(state, payload)
  },
  [DELETING_ASSET] (state, payload) {
    state.deleting = payload
  },
  [DELETING_ASSET_FAILURE] (state, payload) {
    const { id, err } = payload
    state.deleting = { status: false, id, err }
  },
  [INCREMENT_ASSET_COUNT] (state, payload) {
    increment(state, payload)
  },
  [RECEIVE_ASSET_METADATA] (state, payload) {
    receiveMetadata(state, payload)
  },
  [CLEAR_ASSET_STATE] (state, payload) {
    clearLocalState(state, payload)
  },
  [RESET_ASSET_META] (state) {
    resetMetadata(state)
  },
  [CLEAR_STATE] (state) {
    clearState(state)
  }
}

export default {
  state,
  getters,
  mutations
}
